import React, { useState, useEffect } from 'react';
import { Form, Select, Input } from 'antd';
import { useRefCode } from 'hooks';
import type { SelectProps } from 'antd';
import { selectBoxFilterOption } from 'utils/form-utils';

interface FormItemProps {
  form: any
}

const HowKnowFormItem = ({form}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [codeList, setCodeList] = useState<SelectProps['options']>([]);
  const [isEtc, setIsEtc] = useState<boolean>(false);
  /* ======================================================
  * hooks
  * ====================================================== */
  const { refCodeList: howknowList } = useRefCode({field:'how_know'});  

  /* ======================================================
  * events
  * ====================================================== */  
  const handleChange = (value: string) => {
    setIsEtc(value ==='ETC')
  };

  /* ======================================================
  * effects
  * ====================================================== */  
  useEffect(() => {
    const options = howknowList?.sort((a, b)=>a.display_sort - b.display_sort).filter((item) => item.status_type === 'AV' || form.getFieldValue("how_know") == item.name).map((item) => {return {value: item.name, label: item.value}}) || [];
    setCodeList(options);
  }, [howknowList, form]);

  useEffect(() => {
    if (form.getFieldValue('how_know'))
      setIsEtc(form.getFieldValue('how_know') ==='ETC');
  }, [form.getFieldValue('how_know')]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Form.Item name="how_know" style={{ width:'180px', display: 'inline-block', marginRight: '5px' }}>
        <Select 
          onSelect={(value) => handleChange(value)}
          placeholder="인지경로 선택" 
          options={codeList}/>                
      </Form.Item> 
      { (isEtc) && (
        <Form.Item name="how_know_memo" style={{ width:'calc(100% - 180px - 10px)', display: 'inline-block', marginRight: '5px' }}>
          <Input type="text" placeholder='기타 정보 입력'/>  
        </Form.Item>  
        )}   
    </>   
  );
};

export default HowKnowFormItem;
